// English texts. Every key must also exist in nl.js (tests/i18n.mjs).
export default {
  // Navigation
  'nav.sectie.overzicht': 'Overview',
  'nav.sectie.import': 'Import',
  'nav.sectie.systeem': 'System',
  'nav.actiefevent': 'Edition',
  'nav.dashboard': 'Dashboard',
  'nav.teams': 'Registrations',
  'nav.activity': 'Activity log',
  'nav.flagged': 'Flagged',
  'nav.clubs': 'Club register',
  'nav.leden': 'Members',
  'nav.importcsv': 'Import CSV',
  'nav.admins': 'User management',
  'nav.templates': 'Email templates',
  'nav.archived': 'Archived',
  'nav.platform': 'Platform admin',
  'nav.settings': 'Settings',
  'pnav.dash': 'Overview',
  'pnav.orgs': 'Organisations',
  'pnav.sectie.juridisch': 'Legal',
  'pnav.terms': 'Terms',
  'pnav.consent': 'Acceptances',
  'pnav.instellingen': 'Settings',
  'pnav.sectie.koppelingen': 'Integrations',
  'pnav.email': 'Email',
  'pnav.stripe': 'Payments',
  'pnav.terug': 'Back to the organisation',

  // Page titles in the top bar
  'titel.dashboard': 'Dashboard',
  'titel.teams': 'Registrations',
  'titel.activity': 'Activity log',
  'titel.flagged': 'Flagged for review',
  'titel.clubs': 'Club register',
  'titel.leden': 'Members',
  'titel.admins': 'User management',
  'titel.templates': 'Email templates',
  'titel.archived': 'Archived',
  'titel.settings': 'Settings',
  'titel.dash': 'Platform overview',
  'titel.orgs': 'Organisations',
  'titel.terms': 'Terms',
  'titel.consent': 'Acceptances',
  'titel.email': 'Email',
  'titel.stripe': 'Payments',
  'titel.instellingen': 'Platform settings',

  // Sign-in
  'auth.uitleg': 'Sign in with your Google account. Access is restricted to authorised administrators only.',
  'auth.google': 'Continue with Google',
  'auth.geweigerd': 'Access denied',
  'auth.geweigerduitleg': 'Your Google account is not authorised to access this application. Contact the administrator to request access.',
  'auth.uitloggen': 'Sign out',

  // Standard table
  'tabel.zoeken': 'Search',
  'tabel.telling': '{zichtbaar} of {totaal}',
  'tabel.alleswissen': 'Clear all',
  'tabel.nietsgevonden': 'Nothing found',
  'tabel.pasaan': 'Adjust your filters or search.',
  'tabel.leeg': 'No rows yet.',
  'tabel.filterkolom': 'Filter this column',
  'tabel.filter': 'Filter: {kolom}',
  'tabel.filterleeg': 'Empty',
  'tabel.filtergevuld': 'Filled',
  'tabel.bevat': 'Contains…',
  'tabel.wissen': 'Clear',
  'tabel.toepassen': 'Apply',
  'tabel.tagleeg': 'empty',
  'tabel.taggevuld': 'filled',

  // General
  'alg.opslaan': 'Save',
  'alg.annuleren': 'Cancel',
  'alg.sluiten': 'Close',
  'alg.verwijderen': 'Delete',
  'alg.toevoegen': 'Add',
  'alg.ja': 'Yes',
  'alg.nee': 'No',
  'alg.geen': 'None',
  'alg.onbekend': 'Unknown',
  'alg.laden': 'Loading…',
  'alg.fout': 'Something went wrong: {melding}',
  'alg.volgende': 'Next',
  'alg.terug': 'Back',

  // Ledenadministratie, import en export
  "leden.nietbeschikbaar": "Membership administration is not yet available for this organisation. The step E database migration is missing or the module is switched off.",
  "leden.toevoegen": "Add member",
  "leden.importeren": "Import",
  "leden.exporteren": "Export",
  "leden.dubbelen": "{aantal} possible duplicates",
  "leden.status.actief": "Active",
  "leden.status.beeindigd": "Ended",
  "leden.status.geschorst": "Suspended",
  "leden.kol.naam": "Name",
  "leden.kol.geboortedatum": "Date of birth",
  "leden.kol.leeftijd": "Age",
  "leden.kol.lidnummer": "Member no.",
  "leden.kol.groep": "Group",
  "leden.kol.email": "Email",
  "leden.kol.plaats": "City",
  "leden.kol.status": "Status",
  "leden.zelfbeheer": "Self-managed",
  "leden.zelfbeheer.uitleg": "This member manages their own name, address and contact details.",
  "leden.zoek": "Search by name, member number, email or city",
  "leden.leeg": "No members yet. Add one or import a member list.",
  "leden.veld.vast": "Locked. A correction goes through a request to the federation.",
  "leden.veld.persoon": "Managed by the member.",
  "leden.veld.voornaam": "First name",
  "leden.veld.tussenvoegsel": "Name prefix",
  "leden.veld.achternaam": "Last name",
  "leden.veld.geboortedatum": "Date of birth",
  "leden.veld.geslacht": "Gender",
  "leden.veld.nationaliteiten": "Nationality",
  "leden.veld.email": "Email",
  "leden.veld.telefoon": "Phone",
  "leden.veld.straat": "Street",
  "leden.veld.huisnummer": "House number",
  "leden.veld.postcode": "Postcode",
  "leden.veld.plaats": "City",
  "leden.veld.land": "Country",
  "leden.veld.lidnummer": "Member number",
  "leden.veld.trainingsgroep": "Training group",
  "leden.veld.graad_opgave": "Grade (as stated by the club)",
  "leden.veld.notities": "Notes",
  "leden.geslacht.m": "Male",
  "leden.geslacht.v": "Female",
  "leden.geslacht.x": "Other",
  "leden.sectie.persoon": "Person",
  "leden.sectie.contact": "Contact and address",
  "leden.sectie.club": "Club details",
  "leden.sectie.lidmaatschap": "Membership",
  "leden.sectie.ouders": "Parents and guardians",
  "leden.sectie.toestemming": "Consents",
  "leden.sectie.paspoort": "Passport",
  "leden.lid.sinds": "Member since",
  "leden.lid.status": "Status",
  "leden.lid.tot": "Until",
  "leden.ouder.uitleg": "The club records the relationship and is responsible for it. A parent’s access ends automatically on the eighteenth birthday.",
  "leden.ouder.geen": "No parents or guardians recorded.",
  "leden.ouder.naam": "Name of parent or guardian",
  "leden.ouder.email": "Email",
  "leden.ouder.soort": "Relationship",
  "leden.ouder.soort.ouder": "parent",
  "leden.ouder.soort.voogd": "guardian",
  "leden.ouder.soort.verzorger": "carer",
  "leden.ouder.tot": "until {datum}",
  "leden.ouder.beeindigd": "ended on {datum}",
  "leden.ouder.stop": "End",
  "leden.toestemming.uitleg": "Per purpose. A change is recorded as a new entry, with date and who recorded it. Withdrawal applies going forward, not retroactively.",
  "leden.toestemming.beeldmateriaal": "Photo and video",
  "leden.toestemming.mailing_extern": "Mailings from outside the club",
  "leden.toestemming.publicatie_uitslagen": "Name in public results",
  "leden.toestemming.nietgevraagd": "not yet asked",
  "leden.toestemming.bron": "How was consent given?",
  "leden.toestemming.bron.formulier": "Written form",
  "leden.toestemming.bron.mondeling": "Verbally",
  "leden.paspoort.uitleg": "Only visible to those allowed to manage passport details. The number is not written to the audit log.",
  "leden.paspoort.nummer": "Passport number",
  "leden.paspoort.land": "Issuing country",
  "leden.paspoort.vervalt": "Valid until",
  "leden.naopslaan": "After saving you can add parents, consents and passport details.",
  "leden.nieuw": "New member",
  "leden.achternaamverplicht": "Enter at least a last name.",
  "leden.opgeslagen": "Saved",
  "leden.weg.titel": "Delete member",
  "leden.weg.uitleg": "{naam} will be removed from this organisation’s membership records, including membership, parents and consents. Records at other organisations and the federation remain.",
  "leden.weg.klaar": "Member deleted",
  "leden.dubbelen.titel": "Possible duplicates",
  "leden.dubbelen.uitleg": "People with the same last name and date of birth, or the same email address and first name. Check them yourself: they could also be twins or a family.",
  "leden.dubbelen.reden.naam": "same last name and date of birth",
  "leden.dubbelen.reden.email": "same email address and first name",
  "import.titel": "Import member list",
  "import.uitleg": "Choose an Excel file (.xlsx) or CSV. The first row must contain the column names. You will see what happens first; nothing is saved until you confirm.",
  "import.tip.perpersoon": "One row per person. A row with a whole family cannot be processed.",
  "import.tip.paspoort": "Passport numbers are never imported, even if they are in the list.",
  "import.tip.dubbel": "Anyone already in the membership records, or twice in the file, is skipped.",
  "import.leeg": "The file has no rows below the column names.",
  "import.onleesbaar": "This file could not be read: {melding}",
  "import.koppelen.titel": "Map columns: {bestand}",
  "import.koppelen.uitleg": "{aantal} rows found. Check where each column goes. Set what you do not need to Do not use.",
  "import.kol.kolom": "Column in the file",
  "import.kol.voorbeeld": "Example",
  "import.kol.veld": "Becomes",
  "import.kol.rij": "Row",
  "import.kol.naam": "Name",
  "import.kol.opmerking": "Remark",
  "import.nietimporteren": "Not imported",
  "import.geweigerd.paspoort": "Passport details do not belong in a member list and are recorded separately.",
  "import.geweigerd.gezin": "Several people in one cell cannot be split reliably.",
  "import.controleren": "Check",
  "import.controle.titel": "Check before importing",
  "import.controle.nieuw": "{aantal} new",
  "import.controle.overslaan": "{aantal} skipped",
  "import.controle.fout": "{aantal} with errors",
  "import.controle.geweigerd": "These columns will not be imported: {kolommen}",
  "import.controle.schoon": "No remarks. Everything can be imported.",
  "import.start": "Import {aantal} members",
  "import.bezig": "Importing",
  "import.voortgang": "{klaar} of {totaal} processed",
  "import.klaar.titel": "Import complete",
  "import.klaar.uitleg": "{aantal} members added, each with an active membership.",
  "import.klaar.mislukt": "{aantal} rows could not be saved.",
  "import.klaar.daarna": "Then check the list of possible duplicates and collect consents separately: they cannot be derived reliably from a member list.",
  "import.doel.negeren": "Do not use",
  "import.doel.volledige_naam": "Full name (will be split)",
  "import.doel.voornaam": "First name",
  "import.doel.tussenvoegsel": "Name prefix",
  "import.doel.achternaam": "Last name",
  "import.doel.geboortedatum": "Date of birth",
  "import.doel.geslacht": "Gender",
  "import.doel.email": "Email",
  "import.doel.telefoon": "Phone",
  "import.doel.adres": "Full address (will be split)",
  "import.doel.straat": "Street",
  "import.doel.huisnummer": "House number",
  "import.doel.postcode": "Postcode",
  "import.doel.plaats": "City",
  "import.doel.land": "Country",
  "import.doel.nationaliteiten": "Nationality",
  "import.doel.lidnummer": "Member number",
  "import.doel.trainingsgroep": "Training group",
  "import.doel.graad_opgave": "Grade",
  "import.doel.notities": "Notes",
  "import.doel.lid_sinds": "Member since",
  "import.doel.ouder_naam": "Name of parent or guardian",
  "import.doel.ouder1_email": "Email parent 1",
  "import.doel.ouder2_email": "Email parent 2",
  "import.melding.gezinsregel": "Several people on one row. Provide one row per person.",
  "import.melding.achternaam_ontbreekt": "No last name.",
  "import.melding.naam_leeg": "No name.",
  "import.melding.datum_tweecijferig": "Two-digit year ({waarde}); date left empty.",
  "import.melding.datum_onleesbaar": "Date cannot be read ({waarde}); left empty.",
  "import.melding.datum_ongeldig": "Date does not exist ({waarde}); left empty.",
  "import.melding.datum_buiten_bereik": "Date is in the future or before 1900 ({waarde}); left empty.",
  "import.melding.lidsinds_onleesbaar": "Member since cannot be read ({waarde}); left empty.",
  "import.melding.geslacht_onbekend": "Gender not recognised ({waarde}); left empty.",
  "import.melding.nationaliteit_onbekend": "Nationality partly not recognised ({waarde}).",
  "import.melding.email_ongeldig": "Not a valid email address ({waarde}); left empty.",
  "import.melding.bestaat_al": "Already in the membership records; skipped.",
  "import.melding.dubbel_in_bestand": "Already appears earlier in the file (row {rij}); skipped.",
  "export.titel": "Export membership records",
  "export.uitleg": "A complete copy of this organisation’s membership records, in an open format any other system can read.",
  "export.inhoud.json": "JSON per table: people, memberships and roles, parents, consents",
  "export.inhoud.csv": "CSV of the people, opens in Excel",
  "export.inhoud.manifest": "manifest.json with schema version, date, author and counts",
  "export.paspoort": "Include passport details",
  "export.gelogd": "Every export is recorded in the audit log, with your name and the number of people.",
  "export.start": "Export",
  "export.klaar": "Export downloaded",

  // Zelfbeheer, inloglink en tweestapsverificatie
  "auth.of": "or",
  "auth.link.placeholder": "name@example.com",
  "auth.link.knop": "Send link",
  "auth.link.ongeldig": "Enter a valid email address.",
  "auth.link.verstuurd": "A sign-in link has been sent to {email}. Open it on this device.",
  "claim.titel.zelf": "Manage your own details",
  "claim.titel.ouder": "Manage the details of {naam}",
  "claim.uitleg.zelf": "{organisatie} invites you to manage your own details. You then update your name, address and consents yourself, and a change takes effect without the club having to do anything.",
  "claim.uitleg.ouder": "{organisatie} invites you to manage the details of {naam}. This is possible until the eighteenth birthday, unless {naam} extends your access after that.",
  "claim.bevestig": "Confirm",
  "claim.anderaccount": "Sign in with another account",
  "claim.anderemail": "This invitation was sent to {email}, but you are signed in as {ingelogd}. Sign in with the address the invitation was sent to.",
  "claim.status.gebruikt": "This invitation has already been used.",
  "claim.status.ingetrokken": "This invitation was withdrawn by the club.",
  "claim.status.verlopen": "This invitation has expired. Ask the club for a new one.",
  "claim.status.onbekend": "This invitation does not exist. Check that you used the complete link.",
  "claim.fout.geen_recht": "You do not have permission for this.",
  "claim.fout.al_geclaimd": "These details are already managed by the person.",
  "claim.fout.geen_geboortedatum": "Record the date of birth first; self-management is possible from age 16.",
  "claim.fout.onder_16": "Self-management is possible from age 16. Until then a parent manages the details.",
  "claim.fout.onbekende_ouder": "This parent does not belong to this member.",
  "claim.fout.ouder_beeindigd": "The relationship with this parent has ended.",
  "claim.fout.geen_email": "There is no email address to send the invitation to.",
  "claim.fout.onbekend": "This invitation does not exist.",
  "claim.fout.gebruikt": "This invitation has already been used.",
  "claim.fout.ingetrokken": "This invitation has been withdrawn.",
  "claim.fout.verlopen": "This invitation has expired.",
  "claim.fout.ander_email": "Sign in with the email address the invitation was sent to.",
  "claim.fout.te_jong": "This is possible from age 17.",
  "claim.fout.te_lang": "Access can be extended by at most five years.",
  "mijn.titel": "My details",
  "mijn.knop": "My details",
  "mijn.naarbeheer": "To administration",
  "mijn.uitleg": "What you change here applies at the club immediately. Your date of birth and membership are managed by the club.",
  "mijn.alsouder": "you manage these details as a parent",
  "mijn.lidsinds": "Member since {datum}",
  "mijn.sectie.gegevens": "Details",
  "mijn.sectie.ouders": "Parents with access",
  "mijn.sectie.jouwrelatie": "Your relationship",
  "mijn.vast": "Date of birth {geboortedatum}. If it is wrong, ask the club for a correction.",
  "mijn.toestemming.uitleg": "You decide. Withdrawal applies from now on, not to what has already been published.",
  "mijn.ouder.tot": "access until {datum}",
  "mijn.ouder.nietgeclaimd": "not yet in use",
  "mijn.ouder.uitleg": "After your eighteenth birthday your parents’ access ends, unless you extend it.",
  "mijn.ouder.verleng": "Extend access",
  "mijn.ouder.beeindig": "End access",
  "mijn.ouder.beeindigvraag": "This parent will no longer be able to see or change your details. Continue?",
  "mijn.ouder.verlengd": "Access extended",
  "mijn.ouder.beeindigd": "Access ended",
  "tweestap.kop": "Two-step verification",
  "tweestap.titel": "Two-step verification",
  "tweestap.uitleg": "Enter the six-digit code from your authenticator app.",
  "tweestap.controleer": "Verify",
  "tweestap.fout": "This code is not correct. Try again with the current code.",
  "tweestap.aan": "Two-step verification is on for your account.",
  "tweestap.uit": "Your account does not have a second factor yet. As owner or admin you can see and export members’ personal data; please set it up.",
  "tweestap.instellen": "Set up",
  "tweestap.scan": "Scan the QR code with an authenticator app and enter the code.",
  "tweestap.handmatig": "Or enter this key manually:",
  "tweestap.bevestig": "Confirm",
  "tweestap.ingesteld": "Two-step verification set up",
  "tweestap.zonder": "Administrators without a second factor:",
  "tweestap.melding": "Your account does not have two-step verification yet. Set it up under Users and settings, User management.",
  "leden.sectie.zelfbeheer": "Self-management",
  "leden.claim.uitleg": "A member aged 16 or over, and every parent, can manage the details themselves. You receive a link to forward yourself; it only works with the email address it was issued for and is valid for 14 days.",
  "leden.claim.zelf": "Invite to self-manage",
  "leden.claim.ouder": "Invite",
  "leden.claim.teJong": "Self-management is possible from age 16. Invite a parent.",
  "leden.claim.open": "invitation valid until {datum}",
  "leden.claim.klaar": "Invitation created for {email}, valid until {datum}. Forward this link yourself; it is shown only once.",
  "leden.claim.kopieer": "Copy",
  "leden.claim.gekopieerd": "Link copied",
  "leden.aflopend": "{aantal} parent relationships end within 45 days, usually because of an eighteenth birthday.",
  "nav.goedkeuringen": "Approvals",
  "titel.goedkeuringen": "Approvals",
  "vierogen.ingediend": "Proposal submitted. A second administrator must approve it.",
  "vierogen.uitgevoerd": "Correction applied",
  "vierogen.teruggedraaid": "Correction undone",
  "vierogen.alleen": "There is no second authorised person in this organisation, so the action was applied directly. This is recorded in the audit log.",
  "vierogen.wacht": "{handeling} awaits approval (proposed by {door})",
  "vierogen.handeling.finance.adjust": "Adjust balance",
  "vierogen.handeling.finance.writeoff": "Write off balance",
  "vierogen.handeling.finance.reverse": "Undo correction",
  "vierogen.effect.saldo": "Balance from {van} to {naar}",
  "vierogen.effect.afboeken": "Outstanding balance of {bedrag} will be written off",
  "vierogen.effect.terug": "Balance from {van} back to {naar} (invoiced {gefactureerd})",
  "vierogen.nietbeschikbaar": "Approvals are not available yet. The database update for this version has probably not been run.",
  "vierogen.tebeslissen": "To decide",
  "vierogen.tebeslissen.uitleg": "Proposals from other administrators. You cannot decide on your own proposal.",
  "vierogen.goedkeuren": "Approve",
  "vierogen.afwijzen": "Reject",
  "vierogen.niets": "Nothing is waiting for your decision.",
  "vierogen.eigen": "My proposals",
  "vierogen.intrekken": "Withdraw",
  "vierogen.geeneigen": "You have no open proposals.",
  "vierogen.afgerond": "Closed",
  "vierogen.geenafgerond": "No closed proposals yet.",
  "vierogen.status.uitgevoerd": "Applied",
  "vierogen.status.afgewezen": "Rejected",
  "vierogen.status.verlopen": "Expired",
  "vierogen.status.mislukt": "Failed",
  "vierogen.status.ingetrokken": "Withdrawn",
  "vierogen.beleid": "Four-eyes principle",
  "vierogen.beleid.uitleg": "When enabled, the action is only applied after a second administrator approves it. If there is no second authorised person, the action goes ahead directly with a note in the audit log.",
  "vierogen.beleid.aan": "On",
  "vierogen.door": "Proposed by {door} on {wanneer}",
  "vierogen.vervalt": "expires {wanneer}",
  "vierogen.besluit.uitgevoerd": "Approved and applied",
  "vierogen.besluit.afgewezen": "Rejected",
  "vierogen.besluit.verlopen": "This proposal had already expired",
  "vierogen.besluit.mislukt": "Approved, but applying it failed. The registration has changed in the meantime.",
  "vierogen.besluit.open": "Decision recorded. Another approval is still needed.",
  "dispatch.fout.alleen_via_dispatcher": "This change is only possible through the correction buttons, so that four-eyes and the audit log apply.",
  "dispatch.fout.bond_verplicht": "For a federation, four-eyes always applies to this action.",
  "dispatch.fout.alleen_platform": "Only platform administration may change this.",
  "dispatch.fout.onbekend_object": "The registration does not exist (any more).",
  "dispatch.fout.ongeldig_bedrag": "The amount is invalid.",
  "dispatch.fout.niets_af_te_boeken": "There is no outstanding balance to write off.",
  "dispatch.fout.niets_terug_te_draaien": "There is no correction to undo.",
  "dispatch.fout.onbekende_handeling": "Unknown action.",
  "dispatch.fout.geen_recht": "You are not allowed to do this.",
  "dispatch.fout.reden_ontbreekt": "Please give a reason.",
  "dispatch.fout.ongeldig_besluit": "Invalid decision.",
  "dispatch.fout.onbekend_verzoek": "This proposal does not exist.",
  "dispatch.fout.niet_open": "This proposal has already been decided.",
  "dispatch.fout.eigen_voorstel": "You cannot decide on your own proposal.",
  "dispatch.fout.proef_ok": "Trial run succeeded.",
  "bond.sectie": "Federation register",
  "bond.uitleg": "Grades, licences and suspensions are recorded by the federation. Every change is a proposal that a second authorised person must approve.",
  "bond.nietbeschikbaar": "The federation register is not available yet. The database update for this version has probably not been run.",
  "bond.graduaties": "Grades",
  "bond.graduaties.geen": "No grades recorded yet.",
  "bond.graad": "Grade",
  "bond.datum": "Date",
  "bond.examinator": "Examiner or board",
  "bond.bron": "from {bron}",
  "bond.reden": "Reason",
  "bond.reden.voorbeeld": "for example: exam 14 June, North board",
  "bond.voorstellen": "Propose",
  "bond.intrekken": "Revoke",
  "bond.licenties": "Licences",
  "bond.licenties.geen": "No licences.",
  "bond.licentie.soort": "Licence",
  "bond.licentie.geldig": "Valid",
  "bond.licentie.verlopen": "Expired",
  "bond.licentie.ingetrokken": "Revoked",
  "bond.licentie.geensoorten": "There are no licence types yet. Add them under Register settings.",
  "bond.maanden": "{aantal} months",
  "bond.onbeperkt": "valid indefinitely",
  "bond.vanaf": "From",
  "bond.vandaag": "today",
  "bond.tot.optioneel": "Until (empty: default validity)",
  "bond.tot.onbepaald": "Until (empty: indefinite)",
  "bond.schorsing": "Suspension",
  "bond.schorsing.geen": "Not suspended.",
  "bond.schorsing.periode": "Suspended from {van} up to and including {tot}",
  "bond.schorsing.onbepaald": "Suspended from {van}, indefinitely",
  "bond.schorsing.reden": "Reason: {reden}",
  "bond.schorsing.opheffen": "Lift suspension",
  "bond.schorsing.zichtbaar": "Anyone who can see members sees that someone is suspended. Only those who can suspend see the reason.",
  "bond.schorsen": "Suspend",
  "bond.geschorst": "Suspended",
  "bond.geschorst.tot": "Suspended until {datum}",
  "bond.kol.graad": "Grade",
  "bond.instellingen": "Register settings",
  "bond.schaal": "Grading scale",
  "bond.schaal.standaard": "You are using the standard ITF scale. Adjust it if your federation uses a different scale or other names.",
  "bond.schaal.eigen": "Your federation's own scale, from low to high. The order determines which grade is the highest.",
  "bond.schaal.aanpassen": "Adjust scale",
  "bond.schaal.nieuw": "New grade (added at the top)",
  "bond.schaal.leeg": "Every grade needs a name.",
  "bond.omhoog": "Move down the scale",
  "bond.toevoegen": "Add",
  "bond.soorten": "Licence types",
  "bond.soorten.uitleg": "When granted, a licence gets the default validity unless you enter an end date.",
  "bond.soorten.geen": "No licence types yet.",
  "bond.soort.naam": "Name",
  "bond.soort.geldigheid": "Validity in months",
  "bond.soort.actief": "In use",
  "vierogen.handeling.grade.set": "Grant grade",
  "vierogen.handeling.grade.revoke": "Revoke grade",
  "vierogen.handeling.licence.grant": "Grant licence",
  "vierogen.handeling.licence.revoke": "Revoke licence",
  "vierogen.handeling.member.suspend": "Suspend member",
  "vierogen.handeling.member.unsuspend": "Lift suspension",
  "vierogen.effect.graad": "{graad} as of {datum}",
  "vierogen.effect.graad_weg": "{graad} is removed",
  "vierogen.effect.licentie": "{licentie} from {van}, with the default validity",
  "vierogen.effect.licentie_tot": "{licentie} from {van} up to and including {tot}",
  "vierogen.effect.licentie_weg": "{licentie} ends as of today",
  "vierogen.effect.schorsing": "Suspended from {van}, indefinitely",
  "vierogen.effect.schorsing_tot": "Suspended from {van} up to and including {tot}",
  "vierogen.effect.opheffen": "The suspension ends as of today",
  "dispatch.fout.alleen_bond": "This is only possible in an organisation with the federation module.",
  "dispatch.fout.onbekende_graad": "This grade is not on the grading scale.",
  "dispatch.fout.al_toegekend": "This grade or licence has already been granted.",
  "dispatch.fout.onbekende_licentie": "This licence type does not exist or is no longer in use.",
  "dispatch.fout.ongeldige_datum": "The date is not valid: a grade cannot be in the future and an end date cannot be before the start date.",
  "dispatch.fout.al_geschorst": "This member is already suspended in that period.",
  "dispatch.fout.niet_actief": "This has already ended or been revoked.",
  "start.knop": "Start",
  "start.titel": "My {merk}",
  "start.nietbeschikbaar": "The start screen is not fully available yet. The database update for this version has probably not been run.",
  "start.niets": "Nothing has been set up for you yet.",
  "start.mijn": "My details",
  "start.mijn.uitleg": "Your own details as a member, and your children's as a parent.",
  "start.openen": "Open",
  "start.platform": "Platform management",
  "start.alle": "All organisations",
  "start.alle.uitleg": "Modules per organisation. You only see the data of an organisation you are not a member of with platform access: temporary, with a reason, and visible to the organisation.",
  "start.kol.organisatie": "Organisation",
  "start.kol.toegang": "Access",
  "start.module.toernooien": "Tournaments",
  "start.module.leden": "Members",
  "start.module.bond": "Club register",
  "start.module.goedkeuringen": "Approvals",
  "start.module.beheer": "Users and settings",
  "start.stand.actief": "Active",
  "start.stand.uit": "Off",
  "start.stand.nvt": "Not for this type",
  "start.stand.geenrecht": "Not for your role",
  "start.stand.geentoegang": "No access",
  "start.stip.aan": "On",
  "start.stip.uit": "Off",
  "start.stip.nvt": "N/a",
  "start.type.club": "Club",
  "start.type.organisator": "Tournament organiser",
  "start.type.bond": "Federation",
  "start.rolnaam.owner": "Owner",
  "start.rolnaam.admin": "Admin",
  "start.rolnaam.editor": "Editor",
  "start.rolnaam.viewer": "Viewer",
  "start.toegang.lid": "Member",
  "start.toegang.tot": "Platform access until {tijd}",
  "start.toegang.geen": "None",
  "start.toegang.aanvragen": "Request access",
  "start.toegang.reden": "Reason",
  "start.toegang.voorbeeld": "for example: question from the secretary about the import of 12 September",
  "start.toegang.uren": "Hours",
  "start.toegang.kort": "Give a reason of at least ten characters.",
  "start.toegang.platform": "Platform access",
  "start.viaplatform": "You are working here through platform access, not as a member. The organisation can see this, and every change is in the audit log.",
  "super.titel": "Super admin",
  "super.env.production": "PRODUCTION",
  "super.env.staging": "STAGING",
  "super.env.preview": "PREVIEW",
  "super.env.development": "DEVELOPMENT",
  "super.naar": "Go to",
  "super.start": "Start screen",
  "super.platform": "Platform management",
  "super.toegang": "access",
  "super.geentoegang": "no access",
  "super.bekijkals": "View as",
  "super.eigenrol": "Own role",
  "super.simulatie": "You are viewing the app as {rol}. The database still gives you your own rights.",
  "super.inzicht": "Insight",
  "super.aanvraag": "You are not a member of {naam}. Request platform access to see the data.",
  "super.uur": "hours",
  "super.i.email": "Signed in as",
  "super.i.omgeving": "Environment",
  "super.i.organisatie": "Organisation",
  "super.i.echterol": "Actual role",
  "super.i.viatoegang": "Platform access",
  "super.i.bekeken": "Viewing as",
  "super.i.toegang": "Access until",
  "super.i.modules": "Modules",
  "super.i.onbekend": "unknown (everything visible)",
  "super.i.rechten": "Rights on screen",
  "super.i.uitleg": "This is what the app shows. What you are actually allowed to do is decided by the database per action.",
  "nav.module": "Module",
  "nav.sectie.toernooi": "Tournament",
  "start.naarstart": "Go to the start screen",
  "nav.toernooiinstellingen": "Tournament settings",
  "titel.toernooiinstellingen": "Tournament settings",
  "eigendom.nieuw": "New organisation",
  "eigendom.nieuw.uitleg": "A club, federation or independent tournament organiser that will use Tornema. Platform management approves the request; then you accept the terms and become owner. A new tournament within your own organisation is created in the Tournaments module, under Tournament settings.",
  "eigendom.nieuw.knop": "Request a new organisation",
  "eigendom.aanvraag.naam": "Name of the organisation",
  "eigendom.aanvraag.naam.voorbeeld": "for example: North Open Foundation or TKD South",
  "eigendom.aanvraag.datum": "Date of edition",
  "eigendom.aanvraag.land": "Country",
  "eigendom.aanvraag.toelichting": "Notes",
  "eigendom.aanvraag.toelichting.voorbeeld": "What kind of organisation, and for a tournament: where, and how many participants you expect",
  "eigendom.aanvraag.versturen": "Send request",
  "eigendom.aanvraag.verstuurd": "Request sent. You will see here when it has been approved.",
  "eigendom.status.open": "awaiting approval",
  "eigendom.status.goedgekeurd": "approved",
  "eigendom.status.afgewezen": "rejected",
  "eigendom.status.ingetrokken": "withdrawn",
  "eigendom.intrekken": "Withdraw",
  "eigendom.beoordelen": "Requests for a new organisation",
  "eigendom.beoordelen.reden": "Note or reason",
  "eigendom.goedgekeurd": "Approved. The requester now sees the offer to become owner.",
  "eigendom.afgewezen": "Rejected",
  "eigendom.aanbod.nieuw": "Your request for {naam} has been approved",
  "eigendom.aanbod.nieuw.uitleg": "Accept the terms to become owner. Then set up the organisation and invite administrators.",
  "eigendom.aanbod.overdracht": "You have been invited as owner of {naam}",
  "eigendom.aanbod.overdracht.uitleg": "{van} is transferring ownership to you. Reason: {reden}",
  "eigendom.bekijken": "Review and accept",
  "eigendom.aanvaard.uitleg": "As owner you enter into the agreement with the platform on behalf of your organisation. Read the documents and tick them.",
  "eigendom.doc.platform_terms": "Platform agreement",
  "eigendom.doc.dpa": "Data processing agreement",
  "eigendom.doc.user_terms": "Terms of use",
  "eigendom.doc.privacy_policy": "Privacy statement",
  "eigendom.lezen": "read",
  "eigendom.naam": "Your name",
  "eigendom.functie": "Position",
  "eigendom.functie.voorbeeld": "for example: chair",
  "eigendom.bevoegd": "I am authorised to act on behalf of this organisation.",
  "eigendom.aanvaarden": "Accept and become owner",
  "eigendom.welkom": "You are now owner of {naam}",
  "eigendom.verlopen": "This offer has expired. Ask the sender for a new offer.",
  "eigendom.overdragen": "Transfer ownership",
  "eigendom.overdragen.uitleg": "The recipient accepts the terms and becomes owner. Only then does your role change. The offer is valid for 14 days.",
  "eigendom.overdragen.aan": "Email address of the new owner",
  "eigendom.overdragen.daarna": "Afterwards I am",
  "eigendom.blijf.admin": "admin in this organisation",
  "eigendom.blijf.weg": "no longer a member of this organisation",
  "eigendom.overdragen.voorbeeld": "for example: the federation takes over the organisation",
  "eigendom.overdragen.knop": "Send offer",
  "eigendom.overdragen.verstuurd": "Offer sent. The recipient sees it on the start screen after signing in.",
  "eigendom.overdragen.open": "Offer to {naar}, valid until {datum}.",
  "eigendom.fout.aan_jezelf": "You cannot transfer ownership to yourself.",
  "eigendom.fout.al_owner": "This person is already an owner.",
  "eigendom.fout.bevoegdheid": "Confirm that you are authorised.",
  "eigendom.fout.geen_recht": "You are not allowed to do this.",
  "eigendom.fout.geen_voorwaarden": "No terms for owners have been published yet. Contact platform management.",
  "eigendom.fout.naam_functie": "Enter your name and position.",
  "eigendom.fout.naam_ontbreekt": "Enter a name.",
  "eigendom.fout.niet_open": "This has already been handled.",
  "eigendom.fout.ongeldig_besluit": "Invalid choice.",
  "eigendom.fout.ongeldig_email": "This email address is not valid.",
  "eigendom.fout.reden_ontbreekt": "Please give a reason.",
  "eigendom.fout.te_veel_aanvragen": "You already have three open requests. Wait for a decision or withdraw one.",
  "eigendom.fout.voorwaarden_gewijzigd": "Tick all documents. If they have just changed, reload the page.",
  "nav.activiteiten": "Activities",
  "titel.activiteiten": "Activities",
  "start.module.activiteiten": "Activities",
  "act.uitleg": "Gradings, courses and clinics. Tournaments are managed in the Tournaments module.",
  "act.nietbeschikbaar": "Activities are not available yet. Run the migration for step J first.",
  "act.nieuw": "New activity",
  "act.wijzigen": "Edit activity",
  "act.opslaan": "Save",
  "act.opgeslagen": "Activity saved.",
  "act.verwijderen": "Delete",
  "act.verwijderen.bevestig": "Delete this activity? This is only possible while nobody is registered.",
  "act.verwijderd": "Activity deleted.",
  "act.terug": "All activities",
  "act.zoek": "Search activity",
  "act.zoek.deelnemer": "Search participant",
  "act.zoek.lid": "Search by name or member number",
  "act.leeg": "No activities yet.",
  "act.deelnemers.leeg": "Nobody registered yet.",
  "act.kandidaten.leeg": "There are no members left to register.",
  "act.teams": "teams",
  "act.geen": "None",
  "act.toernooi.badge": "via Tournaments",
  "act.toernooi.uitleg": "Registrations for a tournament are managed in the Tournaments module.",
  "act.kol.naam": "Activity",
  "act.kol.soort": "Type",
  "act.kol.datum": "Date",
  "act.kol.status": "Status",
  "act.kol.deelnemers": "Participants",
  "act.kol.tarief": "Fee",
  "act.kol.openstaand": "Outstanding",
  "act.kol.deelnemer": "Participant",
  "act.kol.betaling": "Payment",
  "act.kol.uitslag": "Result",
  "act.soort.toernooi": "Tournament",
  "act.soort.examen": "Grading",
  "act.soort.cursus": "Course",
  "act.soort.clinic": "Clinic",
  "act.status.concept": "Draft",
  "act.status.open": "Registration open",
  "act.status.gesloten": "Registration closed",
  "act.status.afgerond": "Completed",
  "act.status.geannuleerd": "Cancelled",
  "act.status.gewijzigd": "Status changed: {status}.",
  "act.naar.open": "Open registration",
  "act.naar.gesloten": "Close registration",
  "act.naar.afgerond": "Complete",
  "act.naar.geannuleerd": "Cancel",
  "act.annuleren.bevestig": "Cancel {naam}? Registrations and payments remain; handle refunds separately.",
  "act.veld.soort": "Type",
  "act.veld.status": "Status",
  "act.veld.naam": "Name",
  "act.veld.naam.voorbeeld": "for example: Dan grading autumn 2026",
  "act.veld.locatie": "Location",
  "act.veld.tarief": "Fee (euro)",
  "act.veld.start": "Start date",
  "act.veld.eind": "End date",
  "act.veld.inschrijventot": "Registration until",
  "act.veld.max": "Maximum participants",
  "act.veld.minleeftijd": "Minimum age",
  "act.veld.maxleeftijd": "Maximum age",
  "act.veld.mingraad": "Minimum grade",
  "act.veld.licentie": "Required licence",
  "act.veld.uitkomst": "Licence on passing",
  "act.veld.omschrijving": "Description",
  "act.eisen": "Admission",
  "act.eisen.uitleg": "The database checks this on every registration. Age counts on the start date.",
  "act.eisen.geenbond": "Only an organisation with the federation register can set grade or licence requirements.",
  "act.uitkomst.geen": "No licence (participation only)",
  "act.uitkomst.uitleg": "Passing becomes a proposal to grant this licence, with four-eyes approval.",
  "act.eis.leeftijd.tussen": "Age {van} to {tot}",
  "act.eis.leeftijd.vanaf": "Age {van} and over",
  "act.eis.leeftijd.tot": "Up to age {tot}",
  "act.eis.graad": "From {graad}",
  "act.eis.licentie": "Licence {licentie} required",
  "act.eis.tot": "Register until {datum}",
  "act.fout.naam": "Give the activity a name.",
  "act.kpi.deelnemers": "Participants",
  "act.kpi.tarief": "Fee",
  "act.kpi.ontvangen": "Received",
  "act.kpi.openstaand": "Outstanding",
  "act.kpi.uitslagen": "Results",
  "act.inschrijven": "Register members",
  "act.inschrijven.uitleg": "Choose members from the member register. Anyone who does not meet the requirements or is suspended is not registered; you see the reason per person.",
  "act.inschrijven.knop": "Register",
  "act.inschrijven.niemand": "Choose one or more members first.",
  "act.inschrijven.gelukt": "{aantal} registered.",
  "act.inschrijven.deels": "{gelukt} registered, {mislukt} not. See below why.",
  "act.inschrijven.dicht": "Registering is only possible while registration is open.",
  "act.selecteer.zichtbaar": "Select visible",
  "act.afgemeld": "Withdrawn",
  "act.afmelden": "Withdraw",
  "act.afmelden.bevestig": "Withdraw {naam}? The payment remains.",
  "act.afgemeld.gedaan": "Withdrawn.",
  "act.betaling": "Payment",
  "act.betaald": "Paid",
  "act.korting": "Discount",
  "act.betaling.opslaan": "Save payment",
  "act.betaling.opgeslagen": "Payment saved.",
  "act.betaal.paid": "Paid",
  "act.betaal.partial": "Partly paid",
  "act.betaal.unpaid": "Unpaid",
  "act.betaal.nvt": "Nothing to pay",
  "act.betaal.afgeboekt": "Written off",
  "act.correctie": "Correction {bedrag}: {reden}",
  "act.afboeken": "Write off",
  "act.terugdraaien": "Undo correction",
  "act.nieuwegraad": "New grade",
  "act.uitslag.geslaagd": "Passed",
  "act.uitslag.niet_geslaagd": "Not passed",
  "act.uitslag.geen": "No result yet.",
  "act.uitslag.wacht": "The proposal is waiting for a second authorised person. Only then is it in the register.",
  "act.uitslag.vastleggen": "Record result",
  "act.uitslag.uitleg.bond": "Passing becomes a proposal for the register. A second authorised person with the right to grant grades or licences approves it.",
  "act.uitslag.uitleg.club": "The result is kept with the registration. The official register is kept by the federation.",
  "act.uitslagstatus.voorgesteld": "awaiting approval",
  "act.uitslagstatus.vastgelegd": "recorded",
  "act.uitslagstatus.afgewezen": "rejected",
  "act.uitslagstatus.geen_register": "not in the register",
  "act.uitslagstatus.gedaan.voorgesteld": "Result recorded; the proposal is awaiting approval.",
  "act.uitslagstatus.gedaan.vastgelegd": "Result recorded.",
  "act.uitslagstatus.gedaan.geen_register": "Result recorded with the registration.",
  "act.uitslagen": "Enter results",
  "act.uitslagen.leeg": "There are no participants without a recorded result.",
  "act.uitslagen.niets": "Choose a result for at least one participant.",
  "act.uitslagen.gelukt": "{aantal} results recorded.",
  "act.uitslagen.deels": "{gelukt} recorded, {mislukt} not. See below why.",
  "inschrijving.fout.al_ingeschreven": "Already registered.",
  "inschrijving.fout.geboortedatum_onbekend": "Date of birth unknown; needed for the age requirement.",
  "inschrijving.fout.geen_recht": "You are not allowed to register here.",
  "inschrijving.fout.geschorst": "Suspended during the period of the activity.",
  "inschrijving.fout.graad_te_laag": "Grade below the minimum grade.",
  "inschrijving.fout.licentie_ontbreekt": "No valid required licence.",
  "inschrijving.fout.niet_open": "Registration is not open.",
  "inschrijving.fout.onbekende_activiteit": "This activity does not exist (any more).",
  "inschrijving.fout.onbekende_persoon": "Not a member of this organisation.",
  "inschrijving.fout.ongeldig_bedrag": "An amount cannot be negative.",
  "inschrijving.fout.status": "A withdrawn registration cannot be restored. Register again.",
  "inschrijving.fout.te_jong": "Younger than the minimum age.",
  "inschrijving.fout.te_oud": "Older than the maximum age.",
  "inschrijving.fout.te_veel": "At most 500 people at a time.",
  "inschrijving.fout.termijn_voorbij": "The registration period has ended.",
  "inschrijving.fout.toernooi_via_teams": "Registering for a tournament goes through the Tournaments module.",
  "inschrijving.fout.vast": "These details of a registration are fixed.",
  "inschrijving.fout.vol": "The maximum number of participants has been reached.",
  "uitslag.fout.al_vastgelegd": "This grade or licence is already in the register. Revoking goes through the member detail.",
  "uitslag.fout.geen_recht": "You are not allowed to record results.",
  "uitslag.fout.geen_uitkomst": "This type of activity has no result.",
  "uitslag.fout.graad_ontbreekt": "Choose the new grade.",
  "uitslag.fout.niet_mogelijk": "A result is only possible for a registered participant of an ongoing or completed activity.",
  "uitslag.fout.nog_niet": "The activity has not started yet.",
  "uitslag.fout.onbekend": "This registration does not exist (any more).",
  "uitslag.fout.onbekende_graad": "This grade is not on the grading scale.",
  "uitslag.fout.ongeldig": "Choose passed or not passed.",
  "uitslag.fout.voorstel_loopt": "A proposal is already pending. Wait for the decision.",
  "activiteit.fout.eis_alleen_bond": "Only an organisation with the federation register can set grade or licence requirements.",
  "activiteit.fout.onbekende_graad": "This grade is not on the grading scale.",
  "activiteit.fout.onbekende_licentie": "This licence type does not belong to this organisation.",
  "activiteit.fout.toernooi_via_events": "A tournament is created in the Tournaments module.",
  "activiteit.fout.vast": "Type and organisation of an activity are fixed.",
  "reden.uitleg": "The reason is recorded in the audit log and the queue. With four-eyes on, nothing happens until a second authorised person approves.",
  "beheer.verwijderen": "Remove user",
  "beheer.verwijderen.uitleg": "{email} loses access to this organisation once this is carried out.",
  "beheer.rol.titel": "Change role",
  "beheer.rol.uitleg": "Change the role of {email} from {van} to {naar}.",
  "beheer.primair": "The primary administrator cannot be changed or removed.",
  "beheer.geentweestap": "no two-step",
  "beheer.geentweestap.uitleg": "This administrator has not set up a second factor yet.",
  "leden.weg.uitleg2": "What should happen to {naam}?",
  "leden.weg.knop": "Propose",
  "leden.weg.anonimiseren": "Anonymise",
  "leden.weg.anonimiseren.uitleg": "Name, address, contact details and date of birth are erased. Grades, licences, registrations and payments remain, but can no longer be traced to this person.",
  "leden.weg.verwijderen": "Delete completely",
  "leden.weg.verwijderen.uitleg": "Only for a typo or duplicate entry. Not possible if there is a grade, licence, suspension or registration.",
  "export.aanvraag.uitleg": "An export contains personal data. It is logged; with four-eyes on, a second authorised person approves it first. It is then available for 24 hours, for one download.",
  "export.aanvragen": "Request export",
  "export.wacht": "Export requested. After approval it is available here for 24 hours.",
  "export.klaarstaand": "Ready to download:",
  "export.geldig": "valid until {wanneer}",
  "export.ophalen": "Download",
  "export.gelogd2": "Every export is recorded in the audit log, with your reason. At a federation a second authorised person approves it first.",
  "export.soort.leden": "Member export",
  "export.soort.volledig": "Full export",
  "export.volledig.titel": "Full export",
  "export.volledig.uitleg": "All data of this organisation in an open format: members, activities, tournaments, finances, proposals, audit log and settings. JSON per table, CSV of the members and a manifest. Without passwords, tokens or keys.",
  "export.fout.onbekend": "This export does not exist or is not yours.",
  "export.fout.al_opgehaald": "This export has already been downloaded. Request a new one.",
  "export.fout.verlopen": "This export has expired. Request a new one.",
  "export.fout.geen_recht": "You no longer have the right to download this export.",
  "vierogen.handeling.user.role": "Change role",
  "vierogen.handeling.user.remove": "Remove user",
  "vierogen.handeling.person.remove": "Delete or anonymise member",
  "vierogen.handeling.person.export": "Member export",
  "vierogen.handeling.data.export": "Full export",
  "vierogen.effect.rol": "Becomes {rol}.",
  "vierogen.effect.gebruiker_weg": "Loses access to this organisation.",
  "vierogen.effect.lid_weg": "Is deleted completely.",
  "vierogen.effect.lid_anoniem": "Is anonymised; sporting and financial data remain.",
  "vierogen.effect.ledenexport": "Member export, without passport data.",
  "vierogen.effect.ledenexport_paspoort": "Member export, with passport data.",
  "vierogen.effect.volledige_export": "All data of the organisation.",
  "dispatch.fout.eigen_account": "You do not change or remove your own account. Ask another administrator.",
  "dispatch.fout.ongeldige_rol": "Unknown role.",
  "dispatch.fout.geen_wijziging": "This user already has that role.",
  "dispatch.fout.alleen_owner": "Only an owner decides about an owner, both when proposing and when approving.",
  "dispatch.fout.laatste_owner": "This is the last owner. Transfer ownership first.",
  "dispatch.fout.ongeldige_wijze": "Choose delete or anonymise.",
  "dispatch.fout.heeft_historie": "This member has a grade, licence, suspension or registration. Choose anonymise.",
  "tweestap.overzicht.titel": "Two-step verification of administrators",
  "tweestap.overzicht.uitleg": "Owners, admins and platform administrators without a second factor. Only when this list is empty can the requirement be switched on in the database.",
  "tweestap.overzicht.stand": "{met} of {totaal} administrators have a second factor.",
  "tweestap.overzicht.platform": "platform administration",
  "tweestap.overzicht.klaar": "All administrators have a second factor.",
  "tweestap.overzicht.nietbeschikbaar": "Not available. Run the migration for the security step first.",
  "reden.voorbeeld.lid": "for example: duplicate entry, or request from the member",
  "reden.voorbeeld.export": "for example: moving to another system",
  "reden.voorbeeld.gebruiker": "for example: stepping down as treasurer",
  "start.toernooien": "Tournaments: {lijst}",
  "eigendom.aanvraag.soort": "Type of organisation",
  "eigendom.soort.club": "Club",
  "eigendom.soort.organisator": "Independent tournament organiser",
  "eigendom.soort.bond": "Federation",
  "eigendom.aanvraag.toernooi": "Tournament (optional)",
  "eigendom.aanvraag.toernooi.voorbeeld": "for example: North Open",
  "eigendom.aanvraag.metToernooi": "tournament {toernooi}",
  "eigendom.fout.ongeldig_type": "Choose the type of organisation.",
  "toernooi.kaart.titel": "Tournaments",
  "toernooi.kaart.uitleg": "The tournaments of {organisatie}. Each tournament has editions, for example per year. Members, users and payments belong to the organisation, not to a tournament.",
  "toernooi.edities": "{aantal} editions",
  "toernooi.geen": "No tournaments yet.",
  "toernooi.nieuw": "New tournament",
  "toernooi.aanmaken": "Create tournament",
  "toernooi.aangemaakt": "Tournament created.",
  "toernooi.veld.toernooi": "Tournament",
  "toernooi.veld.naam": "Tournament name",
  "toernooi.veld.naam.voorbeeld": "for example: EC 2027 or North Open",
  "toernooi.veld.editie": "Edition name",
  "toernooi.veld.editie.voorbeeld": "for example: North Open 2027",
  "toernooi.veld.datum": "Date of edition",
  "toernooi.veld.uitleg": "Edition and date are optional. For an existing tournament that moves over, start with the edition that comes into Tornema first.",
  "toernooi.fout.naam_ontbreekt": "Give the tournament a name.",
  "toernooi.fout.bestaat_al": "This organisation already has a tournament with that name.",
  "toernooi.fout.andere_organisatie": "This tournament belongs to another organisation.",
  "toernooi.fout.verhuizen_niet_hier": "Moving a tournament to another organisation is not possible here.",
  "organisatie.titel": "Organisation",
  "organisatie.uitleg": "The club, federation or organiser that uses Tornema. This name appears in the sidebar, on the start screen and in emails. Tournaments fall under it.",
  "organisatie.naam": "Name of the organisation",
  "organisatie.type": "Type: {typen}. Changing it goes through platform management.",
  "organisatie.opgeslagen": "Name saved.",
  "nav.toernooien": "All tournaments",
  "nav.sectie.editie": "Edition",
  "titel.toernooien": "Tournaments",
  "toernooi.kol.naam": "Tournament",
  "toernooi.kol.edities": "Editions",
  "toernooi.kol.laatste": "Latest edition",
  "toernooi.kol.teams": "Teams",
  "toernooi.kol.editie": "Edition",
  "toernooi.kol.datum": "Date",
  "toernooi.kol.locatie": "Location",
  "toernooi.zoek": "Search tournament",
  "toernooi.zoek.editie": "Search edition",
  "toernooi.terug": "All tournaments",
  "toernooi.nieuweEditie": "New edition",
  "toernooi.edities.leeg": "No editions yet. Add one with New edition.",
  "ref.kol": "Code",
  "ref.kopieer": "Click to copy the code",
  "ref.gekopieerd": "{code} copied.",
  "mijn.act.titel": "Activities for {naam}",
  "mijn.act.inschrijven": "Register",
  "mijn.act.aanvragen": "Request",
  "mijn.act.intrekken": "Withdraw request",
  "mijn.act.afmeldenviaclub": "Cancel through the club",
  "mijn.act.status.aangevraagd": "Requested",
  "mijn.act.status.ingeschreven": "Registered",
  "mijn.act.status.afgewezen": "Declined",
  "mijn.act.status.afgemeld": "Cancelled",
  "mijn.act.bedrag": "Fee {tarief}, still to pay {open}.",
  "mijn.act.tarief": "Fee {tarief}, payable to the club.",
  "mijn.act.wachtopclub": "Waiting for approval by the club",
  "mijn.act.reden": "Reason: {reden}",
  "mijn.act.akkoorduitleg": "The club reviews your request",
  "mijn.act.vraag.inschrijving": "Register {naam} for {activiteit}?",
  "mijn.act.vraag.aanvraag": "Submit a request for {naam} for {activiteit}? The club decides.",
  "mijn.act.vraag.kosten": "Cost {tarief}, payable to the club.",
  "mijn.act.vraag.afmelden": "Cancel registration for {activiteit}?",
  "mijn.act.ingeschreven": "Registered.",
  "mijn.act.aangevraagd": "Request submitted. The club will let you know.",
  "act.zelf": "Registration by members",
  "act.veld.zelf": "Members and parents can register themselves",
  "act.veld.akkoord": "Requires approval by the club",
  "act.zelf.uitleg": "A member with their own account registers themselves, a parent a child under 18. With approval, it becomes a request that you approve or decline here.",
  "act.zelf.aan": "Open for self-registration",
  "act.zelf.aan.akkoord": "Open for requests by members",
  "act.aanvragen.aantal": "Requests: {aantal}",
  "act.aanvragen.banner": "Open requests: {aantal}. Click a participant to decide.",
  "act.aangevraagd": "Request",
  "act.afgewezen": "Declined",
  "act.kol.bron": "Via",
  "act.bron.beheerder": "Club",
  "act.bron.zelf": "Member",
  "act.bron.ouder": "Parent",
  "act.aanvraag": "Request",
  "act.aanvraag.uitleg": "Requested on {datum} by {door}.",
  "act.aanvraag.reden": "Note for the member (optional)",
  "act.aanvraag.akkoord": "Approve",
  "act.aanvraag.afwijzen": "Decline",
  "act.aanvraag.goedgekeurd": "Request approved; registered.",
  "act.aanvraag.afgewezen": "Request declined.",
  "act.aanvraag.afgewezenom": "Declined: {reden}",
  "inschrijving.fout.geen_aanvraag": "This has already been decided.",
  "inschrijving.fout.reden_te_lang": "The note is too long (500 characters at most).",
  "inschrijving.fout.afmelden_via_club": "Cancelling is now only possible through the club.",
  "dossier.titel": "Sports record",
  "dossier.uitleg.club": "Results entered by the club are confirmed at once. Confirm results from the member or a parent here, or decline them with a reason.",
  "dossier.uitleg.lid": "Add results with evidence, such as a results list or certificate. The club confirms them. A confirmed result can no longer be changed.",
  "dossier.graduaties": "Grades",
  "dossier.graduaties.leeg": "No grades recorded yet.",
  "dossier.graad.opgave": "Grade according to the club: {graad}",
  "dossier.graad.bron.register": "register",
  "dossier.graad.bron.examen": "exam",
  "dossier.uitslagen": "Results",
  "dossier.uitslagen.leeg": "No results yet.",
  "dossier.open": "To confirm: {aantal}",
  "dossier.nieuw": "Add result",
  "dossier.wijzig": "Edit",
  "dossier.status.bevestigd": "Confirmed",
  "dossier.status.onbevestigd": "Not confirmed",
  "dossier.status.afgewezen": "Declined",
  "dossier.bron.club": "Entered by the club",
  "dossier.bron.zelf": "Entered by the member",
  "dossier.bron.ouder": "Entered by a parent",
  "dossier.bron.import": "Imported",
  "dossier.afgewezenom": "Declined: {reden}",
  "dossier.klassering.geen": "No placing",
  "dossier.klassering.plaats": "Place {plaats}",
  "dossier.niveau.club": "Club",
  "dossier.niveau.regionaal": "Regional",
  "dossier.niveau.nationaal": "National",
  "dossier.niveau.internationaal": "International",
  "dossier.onderdeel.tul": "Patterns (tul)",
  "dossier.onderdeel.sparring": "Sparring",
  "dossier.onderdeel.speciale_techniek": "Special technique",
  "dossier.onderdeel.breektest": "Power test",
  "dossier.onderdeel.team_tul": "Team patterns",
  "dossier.onderdeel.team_sparring": "Team sparring",
  "dossier.onderdeel.team_speciale_techniek": "Team special technique",
  "dossier.onderdeel.team_breektest": "Team power test",
  "dossier.onderdeel.overig": "Other",
  "dossier.veld.datum": "Date",
  "dossier.veld.toernooi": "Tournament",
  "dossier.veld.toernooi.voorbeeld": "For example: Open Championship",
  "dossier.veld.stad": "City",
  "dossier.veld.land": "Country (2 letters)",
  "dossier.veld.niveau": "Level",
  "dossier.veld.onderdeel": "Event",
  "dossier.veld.categorie": "Category",
  "dossier.veld.categorie.voorbeeld": "For example: juniors -55 kg",
  "dossier.veld.klassering": "Final placing",
  "dossier.veld.toelichting": "Note",
  "dossier.veld.bewijs": "Evidence (optional)",
  "dossier.bewijs.uitleg": "Pdf, jpg or png, 10 MB at most. Visible only to the member, the parent and the club.",
  "dossier.bewijs.toevoegen": "Evidence",
  "dossier.bewijs.toegevoegd": "Evidence added.",
  "dossier.bewijs.weg": "Remove evidence",
  "dossier.bewijs.weg.vraag": "Remove this evidence?",
  "dossier.weg.vraag": "Remove the result {toernooi} and its evidence?",
  "dossier.verwijderd": "Result removed.",
  "dossier.opgeslagen": "Result saved.",
  "dossier.opgeslagen.open": "Result saved. The club will confirm it.",
  "dossier.bevestig": "Confirm",
  "dossier.afwijs": "Decline",
  "dossier.afwijs.uitleg": "The member sees the reason and can adjust the result.",
  "dossier.afwijs.voorbeeld": "For example: please add the results list",
  "dossier.bevestigd": "Result confirmed.",
  "dossier.afgewezen": "Result declined.",
  "dossier.fout.geen_recht": "You may not view or change this record.",
  "dossier.fout.onbekende_persoon": "This person no longer exists.",
  "dossier.fout.onbekende_uitslag": "This result no longer exists.",
  "dossier.fout.datum_toekomst": "A result cannot be in the future.",
  "dossier.fout.vast": "These details are fixed.",
  "dossier.fout.besluit_via_functie": "Confirming or declining is done with the club's buttons.",
  "dossier.fout.bevestigd": "A confirmed result is changed through the club.",
  "dossier.fout.geen_open_uitslag": "This result has already been decided.",
  "dossier.fout.reden_nodig": "Give a reason for declining.",
  "dossier.fout.reden_te_lang": "The reason is too long (500 characters at most).",
  "dossier.fout.ongeldig_pad": "This file does not belong to this person.",
  "dossier.fout.te_veel_bestanden": "5 pieces of evidence per result at most.",
  "dossier.fout.bestandstype": "Only pdf, jpg or png.",
  "dossier.fout.bestand_te_groot": "The file is larger than 10 MB.",
  "dossier.fout.verplicht": "Date and tournament are required.",
  "dossier.fout.land": "Country as two letters, for example NL or BE.",
  "nav.deelnemers": "Competitors",
  "nav.sporters": "Athlete register",
  "titel.deelnemers": "Competitors",
  "titel.sporters": "Athlete register",
  "dln.menu.titel": "Competitors CSV",
  "dln.menu.sub": "Athletes and categories (competitor entries)",
  "dln.geeneditie": "Choose an edition first.",
  "dln.nietbeschikbaar": "Competitors are not available yet. Has the athletes migration been run?",
  "dln.kpi.sporters": "Athletes",
  "dln.kpi.deelnames": "Entries",
  "dln.kpi.clubs": "Clubs",
  "dln.kpi.landen": "Countries",
  "dln.kpi.minderjarig": "Under 18",
  "dln.kpi.terugkerend": "More than one edition",
  "dln.import": "Import competitors",
  "dln.toonafgemeld": "Show withdrawn ({aantal})",
  "dln.uitleg": "From the Sportdata competitor export. Importing again updates and withdraws whoever is no longer in it.",
  "dln.kol.naam": "Name",
  "dln.kol.club": "Club",
  "dln.kol.land": "Country",
  "dln.kol.geslacht": "Gender",
  "dln.kol.leeftijd": "Age",
  "dln.kol.onderdeel": "Event",
  "dln.kol.categorie": "Category",
  "dln.kol.graad": "Grade",
  "dln.kol.laatsteclub": "Last club",
  "dln.kol.nationaliteit": "Nationality",
  "dln.kol.edities": "Editions",
  "dln.kol.laatste": "Last edition",
  "dln.geslacht.m": "Male",
  "dln.geslacht.v": "Female",
  "dln.geslacht.x": "Other",
  "dln.graad.gup": "Gup {n}",
  "dln.graad.dan": "Dan {n}",
  "dln.afgemeld": "Withdrawn",
  "dln.zoek": "Search by name, club or category",
  "dln.leeg": "No competitors for this edition yet. Import the competitors CSV from Sportdata.",
  "dln.register.uitleg": "All athletes who took part in a tournament of this organisation, across all editions. Other organisations cannot see them.",
  "dln.register.leeg": "No athletes yet.",
  "dln.historie": "Entries ({aantal} editions)",
  "dln.historie.leeg": "No entries.",
  "dln.proef.titel": "Import competitors: {editie}",
  "dln.proef.sporters_nieuw": "New athletes",
  "dln.proef.sporters_bijgewerkt": "Athletes updated",
  "dln.proef.deelnames_nieuw": "New entries",
  "dln.proef.deelnames_afgemeld": "Withdrawn",
  "dln.proef.totaal": "After import: {sporters} athletes, {deelnames} entries, {clubs} clubs.",
  "dln.proef.afmeldwaarschuwing": "{aantal} entries are no longer in this file and will be withdrawn. If that is wrong, this may be a different or incomplete file.",
  "dln.proef.zonderbetaling": "Clubs without a registration in this edition's payments:",
  "dln.proef.zonderregister": "Clubs not in the club register:",
  "dln.proef.fouten": "Skipped or incomplete rows: {aantal}",
  "dln.proef.weggelaten": "Not imported: {kolommen}.",
  "dln.proef.bevestig": "Import",
  "dln.rijfout": "row {rij}: {fout}",
  "dln.rijfout.onvolledig": "athlete ID, last name or category missing",
  "dln.rijfout.dubbel": "duplicate row",
  "dln.rijfout.geboortedatum": "no valid date of birth",
  "dln.gelukt": "Imported: {sporters} athletes, {deelnames} entries.",
  "dln.fout.geen_recht": "You may not import competitors for this edition.",
  "dln.fout.leeg": "The file contains no competitors.",
  "dln.fout.te_veel": "5000 rows at most per import.",
  "dln.fout.formaat": "This is not a Sportdata competitor export (column Athlete ID is missing).",
  "dln.kol.nationaalid": "National ID",
  "dln.nationaalid": "National ID {id}",
  "dln.internationaalid": "International ID {id}",
  "nav.aansluitingen": "Affiliations",
  "titel.aansluitingen": "Affiliations",
  "aans.titel.bond": "Affiliated clubs",
  "aans.titel.club": "My federation",
  "aans.uitleg.bond": "Clubs that join your federation, or that you add yourself. On approval the club is linked to the club register.",
  "aans.uitleg.club": "Here you see which federation your club is affiliated with or has applied to. The federation decides on a request.",
  "aans.status.aangevraagd": "Requested",
  "aans.status.in_gesprek": "In talks",
  "aans.status.actief": "Affiliated",
  "aans.status.beeindigd": "Ended",
  "aans.sectie.beoordelen": "To review",
  "aans.sectie.actief": "Affiliated",
  "aans.sectie.beeindigd": "Ended",
  "aans.leeg": "No affiliations yet.",
  "aans.van": "Requested by {door} on {datum}",
  "aans.sinds": "Affiliated since {datum}",
  "aans.tot": "Ended on {datum}: {reden}",
  "aans.organisatie": "Organisation {naam}",
  "aans.notitie": "Note (optional)",
  "aans.knop.ingesprek": "Set to in talks",
  "aans.knop.goedkeuren": "Approve",
  "aans.knop.afwijzen": "Reject",
  "aans.knop.beeindigen": "End",
  "aans.knop.intrekken": "Withdraw request",
  "aans.knop.aanvragen": "Request affiliation",
  "aans.knop.toevoegen": "Add",
  "aans.knop.registerclub": "Add to register",
  "aans.toevoegen.titel": "Add a club",
  "aans.toevoegen.uitleg": "Add a club from your register as an affiliated club, or first set it to in talks.",
  "aans.toevoegen.club": "Club from the register",
  "aans.toevoegen.status": "Status",
  "aans.toevoegen.geen": "All clubs in the register are already affiliated or requested.",
  "aans.register.titel": "Add a club to the register",
  "aans.register.naam": "Club name",
  "aans.register.plaats": "Town",
  "aans.aanvragen.titel": "Request affiliation",
  "aans.aanvragen.bond": "Federation",
  "aans.aanvragen.geen": "No federations are available to apply to.",
  "aans.goedkeuren.titel": "Approve request",
  "aans.goedkeuren.uitleg": "Link {naam} to your federation's club register. Only you choose which register club it becomes.",
  "aans.goedkeuren.nieuw": "Create a new club in the register ({naam})",
  "aans.goedkeuren.bestaand": "Link to a club that is already in the register",
  "aans.afwijzen.titel": "Reject request",
  "aans.afwijzen.uitleg": "The club sees the reason with the request.",
  "aans.beeindigen.titel": "End affiliation",
  "aans.beeindigen.uitleg.bond": "The affiliation ends today. For now you handle the consequences for members yourself; the reason is in the audit log.",
  "aans.beeindigen.uitleg.club": "Your affiliation with this federation ends today. The federation sees the reason.",
  "aans.reden.voorbeeld": "For example: club closes or switches federation",
  "aans.aangevraagd": "Affiliation requested",
  "aans.goedgekeurd": "Club affiliated",
  "aans.afgewezen": "Request rejected",
  "aans.beeindigd": "Affiliation ended",
  "aans.nietbeschikbaar": "Affiliations are not available yet. Run the affiliation migration.",
  "aans.fout.geen_toegang": "You do not have permission for that.",
  "aans.fout.geen_club": "Only a club can apply.",
  "aans.fout.geen_bond": "This organisation is not a federation.",
  "aans.fout.bestaat_al": "There is already an open affiliation with this federation.",
  "aans.fout.club_onbekend": "This club is not in the register.",
  "aans.fout.status": "This is no longer possible with the current status of the affiliation.",
  "aans.fout.reden_nodig": "A reason is required.",
  "aans.fout.club_al_gekoppeld": "This register club is already linked to another organisation.",
  "aans.fout.bestaat_al_of_naam_bezet": "An affiliation or a club with this name already exists.",
  "aans.fout.einddatum_voor_start": "The end date is before the start date.",
  "aans.fout.naam_bezet": "This club is already in the register.",
  "bond.nummer": "{label} {nummer}",
  "bond.nummer.standaard": "Number",
  "bond.schaal.kies": "Scale from the catalogue",
  "bond.schaal.kies.knop": "Choose scale",
  "bond.soort.nummerlabel": "Name of the number (optional)",
  "bond.soort.nummerlabel.voorbeeld": "For example Plaque number",
  "bond.soort.verplicht": "Number required",
  "bond.soort.metnummer": "with {label}",
  "schaal.fout.geen_toegang": "Only the owner of a federation can choose a scale.",
  "schaal.fout.schaal_onbekend": "This scale does not exist or is not active.",
  "schaal.fout.eigen_schaal_actief": "Your federation has its own scale. That takes precedence over a catalogue scale.",
  "schaal.fout.graden_in_gebruik": "Some grades granted do not fit this scale. Switch only when they match.",
  "dispatch.fout.nummer_niet_toegestaan": "This grade or licence type has no number.",
  "dispatch.fout.nummer_bezet": "This number has already been given to someone else.",
  "dispatch.fout.nummer_nodig": "A number is required for this licence type.",
  "nav.verzoeken": "Requests",
  "titel.verzoeken": "Requests",
  "verz.titel": "Requests",
  "verz.uitleg.org": "Requests between members, clubs and the federation. Each request has its own conversation and a fixed status.",
  "verz.uitleg.bond": "Requests from clubs and members to your federation. Messages can only be added to, never changed.",
  "verz.uitleg.club": "Requests from your members and your club to the federation. Messages can only be added to, never changed.",
  "verz.uitleg.lid": "Submit a request to your federation or club here and follow the conversation.",
  "verz.leeg": "There are no requests yet.",
  "verz.sectie.afgehandeld": "Closed",
  "verz.laatste": "Last message {datum}",
  "verz.nieuw": "New",
  "verz.wacht.opu": "Waiting for you",
  "verz.wacht.op": "Waiting for",
  "verz.wacht.termijn": "Deadline (optional)",
  "verz.wacht.status": "Waiting for {partij}",
  "verz.termijn": "Deadline: {datum}",
  "verz.meekijken": "You are viewing this request as an administrator. You cannot respond on behalf of a party.",
  "verz.opmerking": "Note (optional)",
  "verz.veld.met": "Request to",
  "verz.veld.type": "Type of request",
  "verz.veld.onderwerp": "Subject",
  "verz.veld.bericht": "Message",
  "verz.veld.zichtbaarheid": "Visible to",
  "verz.veld.antwoord": "Write a message",
  "verz.veld.als": "Respond as",
  "verz.veld.namens": "On behalf of",
  "verz.zicht.uitleg": "Determines who can read this message. A message cannot be changed afterwards.",
  "verz.zicht.iedereen": "Everyone involved",
  "verz.zicht.club_bond": "Club and federation only",
  "verz.zicht.eigen": "Only my own party",
  "verz.namens.nee": "For myself",
  "verz.namens.optie": "On behalf of {partij}",
  "verz.namens.bericht": "Posted on behalf of {partij}",
  "verz.knop.nieuw": "New request",
  "verz.knop.openen": "Submit request",
  "verz.knop.terug": "Back to overview",
  "verz.knop.wachten": "Wait for reply",
  "verz.knop.afhandelen": "Close request",
  "verz.knop.heropenen": "Reopen",
  "verz.knop.escaleren": "Escalate",
  "verz.knop.versturen": "Send",
  "verz.knop.opnieuw": "Pick up again",
  "verz.wachten.titel": "Wait for reply",
  "verz.wachten.uitleg": "Choose who you expect a reply from and optionally set a deadline. The request stays open.",
  "verz.afhandelen.titel": "Close request",
  "verz.afhandelen.uitleg": "The request will be closed. The federation can reopen it later.",
  "verz.escaleren.titel": "Escalate request",
  "verz.escaleren.uitleg": "Mark this request as stuck so the federation can see it and pick it up.",
  "verz.heropenen.titel": "Reopen request",
  "verz.heropenen.uitleg": "The request is opened again and everyone involved will see this.",
  "verz.partij.lid": "the member",
  "verz.partij.club": "the club",
  "verz.partij.bond": "the federation",
  "verz.partij.systeem": "the system",
  "verz.status.open": "Open",
  "verz.status.wacht_op_reactie": "Waiting for reply",
  "verz.status.afgehandeld": "Closed",
  "verz.status.geescaleerd": "Escalated",
  "verz.type.aansluiting": "Affiliation",
  "verz.type.opzegging": "Cancellation",
  "verz.type.overstap": "Transfer",
  "verz.type.vrijstelling": "Exemption",
  "verz.type.geschil": "Dispute",
  "verz.type.overig": "Other",
  "verz.log.afgehandeld": "{partij} closed the request.",
  "verz.log.geescaleerd": "{partij} escalated the request.",
  "verz.log.wacht": "{partij} is waiting for a reply from {wacht}.",
  "verz.log.termijn": "Deadline: {datum}.",
  "verz.log.heropend": "{partij} reopened the request.",
  "verz.log.open": "{partij} opened the request.",
  "verz.geopend": "Request submitted.",
  "verz.nietbeschikbaar": "Requests are not available for this organisation.",
  "verz.fout.geen_toegang": "You do not have access to this request.",
  "verz.fout.onbekend_type": "Unknown type of request.",
  "verz.fout.onderwerp_nodig": "Enter a subject.",
  "verz.fout.bericht_nodig": "Enter a message.",
  "verz.fout.geen_bond": "The selected organisation is not a federation.",
  "verz.fout.geen_aansluiting": "There is no affiliation between this club and the federation.",
  "verz.fout.club_klopt_niet": "The selected club does not belong to this request.",
  "verz.fout.persoon_klopt_niet": "The selected person does not belong to this request.",
  "verz.fout.onderwerp_ontbreekt": "Enter a subject.",
  "verz.fout.zichtbaarheid": "This visibility is not allowed.",
  "verz.fout.partij_kiezen": "Choose which party you respond for.",
  "verz.fout.afgehandeld": "This request is closed. Reopen it to respond.",
  "verz.fout.namens_niet_mogelijk": "You cannot respond on behalf of this party.",
  "verz.fout.geen_recht_status": "You are not allowed to change the status of this request.",
  "verz.fout.ongeldige_status": "This status change is not possible.",
  "verz.fout.wacht_op_nodig": "Choose who you expect a reply from.",
  "verz.fout.geen_wijziging": "The request already has that status.",
  "verz.fout.alleen_aanvullen": "Messages cannot be changed or deleted.",
  "leden.kol.club": "Club",
  "leden.club": "Club",
  "leden.club.kies": "Choose a club",
  "leden.club.geen": "No club yet",
  "leden.club.wissel": "Changing club is only possible through a transfer with the consent of both clubs.",
  "leden.club.nodig": "Every member of a federation belongs to a club in the club register.",
  "leden.club.leeg": "The club register is still empty. Add clubs under Federation first.",
  "leden.club.vrijstelling.grand_master": "Exempt from a club: Grand Master",
  "leden.club.vrijstelling.maatwerk": "Exempt from a club: custom",
  "lidm.werklijst.knop": "Members without a club ({aantal})",
  "lidm.werklijst.banner": "{aantal} members have no club yet. Link them to a club in the register.",
  "lidm.werklijst.titel": "Members without a club",
  "lidm.werklijst.uitleg": "These members come from an import or from the old system. Choose the club from the register per group. Members who already belong to another club stay as they are: a second club needs a decision.",
  "lidm.werklijst.geen": "All members have a club or an exemption.",
  "lidm.werklijst.groep": "{naam}: {aantal} members",
  "lidm.werklijst.zonderSleutel": "No club name",
  "lidm.werklijst.bron": "Source: {systeem}, key {sleutel}",
  "lidm.werklijst.kies": "Choose a club",
  "lidm.werklijst.koppel": "Link",
  "lidm.werklijst.auto": "Link automatically",
  "lidm.werklijst.autoUitleg": "Links all members whose club key is already registered for a club in the register.",
  "lidm.werklijst.gekoppeld": "{aantal} members linked.",
  "lidm.werklijst.niets": "Nothing was linked.",
  "lidm.fout.club_onbekend": "This club is not (or no longer) active in the register of this federation.",
  "lidm.fout.vrijstelling_via_dispatcher": "An exemption is set through a proposal with approval, not directly.",
  "lidm.fout.club_wissel_via_overstap": "Changing club is only possible through a transfer.",
  "lidm.fout.overgang_door_systeem": "The transition period is set by the system.",
  "lidm.fout.tweede_club": "This member already belongs to another club. A second club needs a decision.",
  "lidm.fout.club_nodig": "Choose a club from the register. Only a Grand Master or a custom case can be without a club.",
  "lidm.fout.geen_recht": "You are not allowed to link members to a club.",
  "lidm.fout.sleutel_nodig": "This member has no club name or key to link on.",
  "import.club": "Club of the imported members",
  "import.club.uitleg": "All members in this file are added to this club.",
  "import.club.nodig": "Choose a club first.",
  "dispatch.fout.heeft_club": "This member already has a club and cannot be exempted.",
  "dispatch.fout.al_vrijgesteld": "This member is already exempt.",
  "dispatch.fout.niet_vrijgesteld": "This member is not exempt.",
  "dispatch.fout.onbekende_soort": "Choose Grand Master or custom.",
  "vierogen.handeling.member.exempt": "Exemption from the club requirement",
  "vierogen.handeling.member.unexempt": "Lift exemption from the club requirement",
  "bond.vrijstelling": "Club requirement",
  "bond.vrijstelling.uitleg": "A federation member belongs to a club. A Grand Master or a member with a custom arrangement can be without one. You propose this with a reason and a second person approves it.",
  "bond.vrijstelling.geen": "No exemption needed: this member has a club.",
  "bond.vrijstelling.club": "Club: {club}",
  "bond.vrijstelling.soort": "Type of exemption",
  "bond.vrijstelling.grand_master": "Grand Master",
  "bond.vrijstelling.maatwerk": "Custom",
  "bond.vrijstelling.nu": "Exempt: {soort}",
  "bond.vrijstelling.opheffen": "Lift exemption",
  "bond.vrijstelling.vrijstellen": "Propose exemption",
  "bond.vrijstelling.geenlidmaatschap": "This member has no active membership.",
  "lidm.titel": "Your membership",
  "lidm.uitleg": "Here you see which club and federation you belong to. Cancelling, moving or adding a second club needs the agreement of the parties involved. You can follow progress below.",
  "lidm.club": "Club: {club}",
  "lidm.geenClub": "No club",
  "lidm.sinds": "member since {datum}",
  "lidm.eindigt": "ends on {datum}",
  "lidm.overgang": "You have until {datum} to choose a new club. After that your membership ends.",
  "lidm.lopend": "A change is already in progress",
  "lidm.knop.opzeggen": "Cancel",
  "lidm.knop.overstappen": "Move to another club",
  "lidm.knop.tweede": "Second club",
  "lidm.knop.indienen": "Submit",
  "lidm.knop.akkoord": "Agree",
  "lidm.knop.bezwaar": "Object",
  "lidm.knop.doorzetten": "Go ahead anyway",
  "lidm.knop.afwijzen": "Reject",
  "lidm.knop.intrekken": "Withdraw",
  "lidm.aanvraag.titel.opzegging": "Cancel membership",
  "lidm.aanvraag.titel.overstap": "Move to another club",
  "lidm.aanvraag.titel.tweede_club": "Add a second club",
  "lidm.aanvraag.uitleg.opzegging": "The club and the federation are notified. If the club does not respond within 14 days, it receives a reminder and the federation decides. The membership ends on the chosen date.",
  "lidm.aanvraag.uitleg.overstap": "The current and the new club are notified. If the current club does not respond within 14 days, it receives a reminder and the federation decides. The new club always agrees itself. On the chosen date the membership moves to the new club.",
  "lidm.aanvraag.uitleg.tweede_club": "The current and the new club are notified. Once they agree, the member belongs to both clubs.",
  "lidm.veld.club": "New club",
  "lidm.veld.datum": "Effective date",
  "lidm.veld.toelichting": "Explanation",
  "lidm.actie.opzegging": "Cancellation",
  "lidm.actie.overstap": "Move",
  "lidm.actie.tweede_club": "Second club",
  "lidm.van": "from {club}",
  "lidm.naar": "to {club}",
  "lidm.per": "on {datum}",
  "lidm.status.open": "Awaiting decision",
  "lidm.status.akkoord": "Scheduled",
  "lidm.status.uitgevoerd": "Completed",
  "lidm.status.afgewezen": "Rejected",
  "lidm.status.verlopen": "Lapsed",
  "lidm.wacht.datum": "All parties agree. The change takes effect on {datum}.",
  "lidm.termijn": "Without a response this request lapses after {datum}.",
  "lidm.escalatie": "An objection was raised. The federation decides.",
  "lidm.rol.lid": "Member",
  "lidm.rol.van_club": "Current club",
  "lidm.rol.naar_club": "New club",
  "lidm.rolstatus.wacht": "awaiting response",
  "lidm.rolstatus.akkoord": "agreed",
  "lidm.rolstatus.bezwaar": "objection",
  "lidm.rol.stilzwijgend": "by silence",
  "lidm.rol.stilzwijgendVanaf": "agreed by silence from {datum}",
  "lidm.rol.namens": "recorded by the federation on behalf of this party",
  "lidm.bezwaar.titel": "Object",
  "lidm.bezwaar.uitleg": "When there is an objection the federation decides. Briefly explain why you object.",
  "lidm.bezwaar.veld": "Reason for the objection",
  "lidm.bond.titel": "Federation decision",
  "lidm.bond.uitleg": "An objection was raised. Your decision and explanation are visible to all parties involved.",
  "lidm.bond.veld": "Explanation of the decision",
  "lidm.ingediend": "The request has been submitted.",
  "lidm.besloten": "Your decision has been recorded.",
  "lidm.ingetrokken": "The request has been withdrawn.",
  "lidm.sectie.afgerond": "Recently completed",
  "lidm.sectie.wacht": "Awaiting your decision",
  "lidm.log.aangevraagd": "{partij} requested a change effective {datum}.",
  "lidm.log.akkoord": "All parties agree. The change takes effect on {datum}.",
  "lidm.log.uitgevoerd": "The change has been carried out.",
  "lidm.log.afgewezen": "The request was rejected. {reden}",
  "lidm.log.verlopen": "The request lapsed. {reden}",
  "lidm.log.rolakkoord": "{partij} agrees ({rol}).",
  "lidm.log.bezwaar": "{partij} objected ({rol}).",
  "lidm.log.stilzwijgend": "No response was received within the term.",
  "lidm.log.namens": "Recorded by the federation on behalf of this party.",
  "lidm.log.bond.doorgezet": "{partij} decided to go ahead with the change.",
  "lidm.log.bond.afgewezen": "{partij} rejected the change.",
  "lidm.reden.ingetrokken": "Withdrawn by the requester.",
  "lidm.reden.bezwaar": "An objection was raised.",
  "lidm.reden.bond": "Decision of the federation.",
  "lidm.reden.termijn": "The 30 day term has passed.",
  "lidm.reden.lidmaatschap_gewijzigd": "The membership changed in the meantime.",
  "lidm.reden.club_niet_meer_actief": "The club is no longer active in the register.",
  "lidm.fout.geen_toegang": "You do not have access to this.",
  "lidm.fout.onbekend": "This membership was not found.",
  "lidm.fout.niet_actief": "This membership is not active.",
  "lidm.fout.geen_bond": "This membership does not belong to a federation with a club register.",
  "lidm.fout.onbekende_actie": "Unknown type of change.",
  "lidm.fout.datum_ongeldig": "Choose a date from today, within one year.",
  "lidm.fout.al_lopend": "A change is already in progress for this membership.",
  "lidm.fout.vrijgesteld": "This member is exempt from a club. A move does not apply.",
  "lidm.fout.geen_club": "This member has no club.",
  "lidm.fout.zelfde_club": "This is already the current club.",
  "lidm.fout.al_lid": "This member already belongs to this club.",
  "lidm.fout.partij_kiezen": "Choose on whose behalf you submit.",
  "lidm.fout.toelichting_nodig": "An explanation is required and may not exceed 4000 characters.",
  "lidm.fout.rol_onbekend": "This party is not part of this request.",
  "lidm.fout.al_besloten": "This party has already decided.",
  "lidm.fout.niet_open": "This request is no longer open.",
  "lidm.fout.geescaleerd": "An objection was raised. The federation decides.",
  "lidm.fout.niet_geescaleerd": "This request is not with the federation.",
  "nav.clubregister": "Clubs",
  "titel.clubregister": "Club register",
  "clubreg.titel": "Club register",
  "clubreg.uitleg": "All clubs of your federation. This register is the source for the club choice on a member. A club cannot be deleted, only archived once it has no members.",
  "clubreg.zoek": "Search by name, town or code",
  "clubreg.filter.actief": "Active",
  "clubreg.filter.gearchiveerd": "Archived",
  "clubreg.filter.alle": "All",
  "clubreg.kol.naam": "Club",
  "clubreg.kol.code": "Code",
  "clubreg.kol.plaats": "Town",
  "clubreg.kol.leden": "Members",
  "clubreg.kol.aansluiting": "Affiliation",
  "clubreg.kol.status": "Status",
  "clubreg.aansluiting.geen": "Not affiliated",
  "clubreg.status.gearchiveerd": "Archived",
  "clubreg.leeg": "The club register is still empty. Add a club.",
  "clubreg.geen": "No clubs found.",
  "clubreg.aantal": "{aantal} clubs",
  "clubreg.nietbeschikbaar": "The club register is not available for this organisation.",
  "clubreg.knop.toevoegen": "Add club",
  "clubreg.knop.opslaan": "Save",
  "clubreg.knop.archiveren": "Archive",
  "clubreg.knop.herstellen": "Restore",
  "clubreg.nieuw.titel": "Add club",
  "clubreg.veld.naam": "Club name",
  "clubreg.veld.plaats": "Town",
  "clubreg.veld.land": "Country (code)",
  "clubreg.veld.email": "Club email address",
  "clubreg.geclaimd": "This club has its own Tornema environment.",
  "clubreg.leden.titel": "Members ({aantal})",
  "clubreg.leden.geen": "No members belong to this club yet.",
  "clubreg.toegevoegd": "The club has been added.",
  "clubreg.opgeslagen": "The club has been saved.",
  "clubreg.gearchiveerd": "The club has been archived.",
  "clubreg.hersteld": "The club has been restored.",
  "clubreg.fout.dubbel": "An active club with this name is already in the register.",
  "clubreg.fout.naam": "Enter the name of the club.",
  "clubreg.fout.land": "The country is a two letter code, for example NL.",
  "clubreg.fout.leden": "This club still has {aantal} members. You can only archive it when it has no members.",
  "lidm.aanvraag.uitlegStil.opzegging": "The club and the federation are notified. If the club does not respond within 14 days, that counts as agreement. The membership ends on the chosen date.",
  "lidm.aanvraag.uitlegStil.overstap": "The current and the new club are notified. If the current club does not respond within 14 days, that counts as agreement. The new club always agrees itself. On the chosen date the membership moves to the new club.",
  "lidm.rol.herinneringVanaf": "without a response a reminder on {datum}, then the federation decides",
  "lidm.rol.herinnerd": "reminded on {datum}",
  "lidm.bondtaak": "The 14 day term has passed. A reminder was sent. If the party does not respond, the federation decides. Until then the request stays open.",
  "lidm.bond.uitlegTaak": "A party did not respond within 14 days. You decide for that party. The member in a transfer and the new club always agree themselves. Your decision and explanation are visible to all parties involved.",
  "lidm.log.herinnering": "No response within 14 days ({rol}). A reminder was sent; the federation decides if there is no response.",
  "lidm.fout.onderbouwing_nodig": "A justification of at least 20 characters is required: when notifications were tested end to end and which legal approval applies.",
  "clubleden.knop": "Members at the federation ({aantal})",
  "clubleden.titel": "Members at the federation",
  "clubleden.uitleg": "These members are registered with the federation at your club. Their details are on one person record at the federation; you see them as long as they belong to your club. A cancellation or transfer needs an explanation. The member is heard, and in a transfer the new club as well.",
  "clubleden.leeg": "The federation has no members registered at your club.",
  "import.doel.club": "Club (link to the club register)",
  "import.clubs.titel": "Clubs in the file",
  "import.clubs.uitleg": "For each spelling in the file, the club from the register. Clubs that were found are already chosen. A suggestion only counts once you confirm it. Anything you do not link goes to the work list Members without a club; the import carries on.",
  "import.clubs.kol.bestand": "In the file",
  "import.clubs.kol.leden": "Members",
  "import.clubs.kol.club": "Club in the register",
  "import.clubs.kol.stand": "Status",
  "import.clubs.leeg": "(no club given)",
  "import.clubs.werklijst": "Still to link (work list)",
  "import.clubs.lijktOp": "Looks like",
  "import.clubs.bevestig": "Confirm",
  "import.clubs.status.exact": "Found",
  "import.clubs.status.voorstel": "Suggestion",
  "import.clubs.status.keuze": "Several clubs, choose one",
  "import.clubs.status.onbekend": "Not found",
  "import.klaar.werklijst": "{aantal} members are still without a club on the work list Members without a club. Link them there per group.",
  "lidm.fout.import_ongeldig": "The import could not be processed: too many rows at once or a club name longer than 200 characters.",
  "leden.verzoek.knop": "Open a request about this member",
  "leden.verzoek.titel": "Request about {naam}",
  "leden.verzoek.uitleg": "The request is about this member and, if the member has a club, also goes to that club. Start a cancellation or transfer in the member form.",
  "verz.teller": "{aantal} waiting for you",
};
